import { useEffect } from 'react';
import {
  isLikelyMutatingControl,
  offlineWriteMessage,
  useOnlineStatus,
} from '../../utils/onlineStatus';

function findGuardedControl(target) {
  return target?.closest?.('button, a, input[type="button"], input[type="submit"]') || null;
}

export default function OfflineWriteGuard() {
  const online = useOnlineStatus();

  useEffect(() => {
    if (online) return undefined;

    const blockOfflineSubmit = (event) => {
      event.preventDefault();
      event.stopPropagation();
      window.alert(offlineWriteMessage('make changes'));
    };

    const blockOfflineMutations = (event) => {
      const control = findGuardedControl(event.target);
      if (!control || control.closest('[data-offline-allow="true"]')) return;
      if (!isLikelyMutatingControl(control)) return;
      event.preventDefault();
      event.stopPropagation();
      window.alert(offlineWriteMessage('make changes'));
    };

    document.addEventListener('submit', blockOfflineSubmit, true);
    document.addEventListener('click', blockOfflineMutations, true);
    return () => {
      document.removeEventListener('submit', blockOfflineSubmit, true);
      document.removeEventListener('click', blockOfflineMutations, true);
    };
  }, [online]);

  return null;
}
